module.exports = __webpack_public_path__ + "img/tellUs.d77cdf2.svg";